import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {Button} from '../button/button';
// @ts-expect-error - imported from .js/.jsx file
import {DownloadIcon} from '../icon/svg/download-icon';
import {SelectMenu} from '../select-menu/select-menu';
import type {SelectMenuOption} from '../select-menu/select-menu';

import styles from './action-menu.module.css';

export type {SelectMenuOption};

type ActionMenuProps = {
    onClick?: () => any;
    onOpenChange?: (isOpen: boolean) => void;
    options: SelectMenuOption[];
    getRef?: (arg1?: HTMLElement | null | undefined) => void;
    size?: 'normal' | 'small' | 'tiny';
    hasHoverBackground?: boolean;
    hasDarkHoverBackground?: boolean;
    as?: 'div' | 'button';
    showAsButton?: boolean;
    buttonText?: string;
    callMountId?: string;
    padding?: 'none' | 'less' | 'normal' | 'horizontal';
    dotColor?: 'grey' | 'off-white';
    offsetX?: number;
    offsetY?: number;
    fitContent?: boolean;
};

type ActionMenuState = {
    isOpen: boolean;
    tooltipText: string | null | undefined;
};

export class ActionMenu extends React.PureComponent<ActionMenuProps, ActionMenuState> {
    anchor: HTMLElement | null | undefined;
    static defaultProps = {
        size: 'normal',
        as: 'button',
        dotColor: 'grey',
        padding: 'normal',
        offsetX: 0,
        offsetY: 0,
    };

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isOpen: false,
            tooltipText: null,
        };
    }

    componentDidUpdate(prevProps: ActionMenuProps, prevState: ActionMenuState) {
        if (this.state.tooltipText && this.state.tooltipText !== prevState.tooltipText) {
            ReactTooltip.show(this.anchor);
            setTimeout(() => {
                ReactTooltip.hide(this.anchor);
                this.setState({tooltipText: null});
            }, 2000);
        }

        if (this.state.isOpen !== prevState.isOpen) {
            if (this.props.onOpenChange) {
                this.props.onOpenChange(this.state.isOpen);
            }
        }
    }

    render() {
        const dotsContainerStyle = classnames(styles['dots-container'], {
            [styles['dots-container--hover']]: this.props.hasHoverBackground,
            [styles['dots-container--dark-hover']]: this.props.hasDarkHoverBackground,
            [styles['dots-container--tiny']]: this.props.size === 'tiny',
            [styles['dots-container--less-padding']]: this.props.padding === 'less',
            [styles['dots-container--no-padding']]: this.props.padding === 'none',
            [styles['dots-container--horizontal-padding']]: this.props.padding === 'horizontal',
            [styles['dots-container--fit-content']]: this.props.fitContent,
        });

        const dotStyle = classnames(styles.dot, {
            [styles['dot--small']]: this.props.size === 'small',
            [styles['dot--tiny']]: this.props.size === 'tiny',
            [styles['dot--grey']]: this.props.dotColor === 'grey',
            [styles['dot--off-white']]: this.props.dotColor === 'off-white',
        });

        const Tag = this.props.as;

        return (
            <>
                {this.props.showAsButton ? (
                    <div id={this.props.callMountId}>
                        <Button
                            size='big'
                            icon={DownloadIcon}
                            variant='primary'
                            // @ts-expect-error
                            onClick={this.handleButtonClick}
                            // @ts-expect-error
                            getButtonRef={(node) => {
                                this.anchor = node;
                                if (this.props.getRef) {
                                    this.props.getRef(node);
                                }
                            }}
                        >
                            {this.props.buttonText || 'Export'}
                        </Button>
                    </div>
                ) : (
                    // @ts-expect-error
                    <Tag
                        id={this.props.callMountId}
                        onClick={this.handleButtonClick}
                        // @ts-expect-error
                        ref={(node) => {
                            this.anchor = node;
                            if (this.props.getRef) {
                                this.props.getRef(node);
                            }
                        }}
                        data-tip={this.state.tooltipText}
                        data-delay-show='0'
                        data-place='bottom'
                        className={dotsContainerStyle}
                    >
                        <div className={dotStyle} />
                        <div className={dotStyle} />
                        <div className={dotStyle} />
                    </Tag>
                )}
                {this.state.isOpen ? (
                    <SelectMenu
                        options={this.props.options}
                        anchor={this.anchor}
                        location='bottom-left'
                        offsetX={this.props.offsetX}
                        offsetY={this.props.offsetY}
                        customStyles={
                            this.props.showAsButton ? {marginRight: -16} : {marginLeft: -16}
                        }
                        onClose={this.handleMenuClose}
                    />
                ) : undefined}
            </>
        );
    }

    handleButtonClick = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.props.onClick) {
            this.props.onClick();
        }

        this.setState(toggleOpen);
    };

    handleMenuClose = (e?: React.SyntheticEvent<any>, tooltipText: string | null = null) => {
        if (e && !e.isPropagationStopped()) {
            e.stopPropagation();
        }

        this.setState({
            isOpen: false,
            tooltipText: tooltipText,
        });
    };
}

// @ts-expect-error
function toggleOpen(prevState) {
    return {
        isOpen: !prevState.isOpen,
    };
}
